import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http:HttpClient) { }

  signin(login):Observable<any> {
      return this.http.post('login', login);
  }
  machine_count():Observable<any> {
    return this.http.get('machine_count')
  }

  true():Observable<any> {
    return this.http.get('check_status')
  }
  machinelist():Observable<any> {
    return this.http.get('hmi_macs');
}
idlereasonlist():Observable<any> {
  return this.http.get('hmi_idles');
}
macroentry(data):Observable<any> {
  return this.http.post('entry',data);
}

tabdata(machine):Observable<any> {
  return this.http.get('details?machine='+machine)
}

  // forgot(params):Observable<any> {
  //   return this.http.get('sessions/forgot_pwd='+params)
  // }
  tabgantt(machine):Observable<any> {
    return this.http.get('mac_setting_report?machine='+machine)
  }


   // pagess:any=["Andon Dashboard","Live OEE","Machine status chart","Oee Report","Mail Setting","Efficiency Report","General Report","Idle Reason Report","Compare Chart","Quality Entry","M-Dashboard","Trend Chart","M-Machine","Alarms","Alarm Report","Machine","Shift","User","Component","Operator","Reason"]
  pageservice(val: any): string {
    if(val === "Andon Dashboard") {
      return "/main-dashboard";
    } else if(val === "Live OEE") {
      return "/oee-dashboard";
    }else if(val === "Machine status chart") {
      return "/machinestatuschart"
     } else if(val === "Reports") {
      return "/reports-all";
    }else if(val === "Mail Setting"){
      return "/mailsetting"
    } else if(val === "Efficiency Report") {
      return "/mefficiency";
    } else if(val === "General Report") {
      return "/generalreport";
    } else if(val === "Idle Reason Report") {
      return "/idle_report";
    } else if(val === "Compare Chart") {
      return "/Overallcomparechart";
    } else if(val === "Quality Entry") {
      return "/newquality";
    }
    else if(val === "M-Dashboard"){
      return "/m-dashboard"
    }
    else if(val === "Trend Chart"){
      return "/trendcharts"
    }
    else if(val === "M-Machine"){
       return "/machine"
    }
    else if(val === "Alarms"){
      return "/alarm"
    }
    else if(val === "Alarm Report"){
      return "/alarmreport"
    }
     else if(val === "Machine") {
      return "/machine_registration";
    } else if(val === "Shift") {
      return "/shift";
    } else if(val === "User") {
      return "/user_management";
    } else if(val === "Component") {
      return "/component";
    } else if(val === "Operator") {
      return "/operator_registration";
    } 
    else if(val === "Reason") {
      return "/reason";
    }
    else if(val === "CycleChart") {
      return "/cycle-time-chart";
    }
    else if(val === "Insights") {
      return "/insights";
    }
    else if(val === "AllocationReports") {
      return "/report-allocations";
    }
     else {
      return "/default-page"; // Default return value for cases not handled above
    }
  }

 
  pageservice1(val: any): string {
    if(val === "/main-dashboard") {
      return "Andon Dashboard";
    } else if(val === "/oee-dashboard") {
      return "Live OEE";
    } else if(val === "/machinestatuschart") {
      return "Machine status chart";
    } else if(val === "/reports-all") {
      return "Reports";
    } else if(val === "/mailsetting") {
      return "Mail Setting";
    } else if(val === "/mefficiency") {
      return "Efficiency Report";
    } else if(val === "/generalreport") {
      return "General Report";
    } else if(val === "/idle_report") {
      return "Idle Reason Report";
    } else if(val === "/Overallcomparechart") {
      return "Compare Chart";
    } else if(val === "/newquality") {
      return "Quality Entry";
    } else if(val === "/m-dashboard") {
      return "M-Dashboard";
    } else if(val === "/trendcharts") {
      return "Trend Chart";
    } else if(val === "/machine") {
      return "M-Machine";
    } else if(val === "/alarm") {
      return "Alarms";
    } else if(val === "/alarmreport") {
      return "Alarm Report";
    } else if(val === "/machine_registration") {
      return "Machine";
    } else if(val === "/shift") {
      return "Shift";
    } else if(val === "/user_management") {
      return "User";
    } else if(val === "/component") {
      return "Component";
    } else if(val === "/operator_registration") {
      return "Operator";
    } else if(val === "/reason") {
      return "Reason";
    }
    else if(val === "/cycle-time-chart") {
      return "CycleChart";
    } else if(val === "/insights") {
      return "Insights";
    }
    else if(val === "/report-allocations") {
      return "AllocationReports";
    }
     else {
      return "Default Page"; // Default return value for cases not handled above
    }
}

}
